<template>
  <div
    class="fill-height doc-page"
    :style="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? `padding-bottom: 0px; padding-top: 62px;` : `padding-bottom: 610px; padding-top: 64px;`">
    <v-dialog
      persistent
      scrollable
      v-if="dialog.filter"
      v-model="dialog.filter"
      width="450">
      <v-card class="filter-dialog">
        <div class="d-flex align-center px-5 py-4 filter-dialog__header">
          <v-icon size="16" :color="set_color" class="mr-2">mdi-tune-variant</v-icon>
          <div class="filter-dialog__title">
            Filter Data
          </div>
          <v-spacer />
          <v-btn
            width="32"
            height="32"
            elevation="0"
            icon
            class="px-0"
            @click="dialog.filter = false;">
            <v-icon size="20" color="#8A8F98">mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text class="pb-2 pt-4">
          <div class="mt-0">
            <v-text-field
              solo
              flat
              hide-details
              class="mb-3"
              v-model="filter.title"
              clearable
              @click:clear="filter.title = ''"
              @keydown.enter.prevent="applyFilter()"
              :color="`${set_color}`"
              placeholder="Judul">
            </v-text-field>
            <v-select
              :items="years"
              :color="`${set_color}`"
              :item-color="`${set_color}`"
              hide-details
              v-model="filter.year"
              clearable
              @click:clear="filter.year = ''"
              item-text="text"
              item-value="value"
              placeholder="Tahun"
              solo
              flat>
            </v-select>
          </div>
        </v-card-text>
        <v-card-actions class="pa-4 pt-2">
          <v-btn
            elevation="0"
            :color="set_color"
            block
            height="46"
            @click="applyFilter()"
            class="text-capitalize font-weight-bold white--text filter-sidebar__btn">
            <v-icon size="18" class="mr-2">mdi-magnify</v-icon>
            Cari
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout wrap>
      <v-flex>
        <section>
          <v-container>
            <div>
              <v-row>
                <v-col cols="12" md="9">
                  <div class="doc-header" :class="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? 'mt-1' : ''">
                    <div class="doc-header__topline">
                      <div class="doc-header__eyebrow" :style="`color: ${set_color}`">Program Pembentukan Perda</div>
                      <button
                        v-if="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm'"
                        type="button"
                        class="doc-filter-trigger"
                        @click="dialog.filter = true">
                        <v-icon size="17" :color="set_color">mdi-tune-variant</v-icon>
                        <span>Filter</span>
                      </button>
                    </div>
                    <div class="doc-header__main">
                      <div class="doc-header__title-wrap">
                        <div class="doc-header__title" :class="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? 'doc-header__title--lg' : 'doc-header__title--sm'">
                          Propemperda
                        </div>
                        <div class="doc-header__subtitle">
                          Daftar dokumen program pembentukan peraturan daerah.
                        </div>
                      </div>
                      <div class="doc-header__meta" v-if="!process.load">
                        <div class="doc-header__count">
                          {{ pagination.total_data || list.length }} dokumen
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mb-4" v-if="dialog.filter === false && hasActiveFilter">
                    <div class="search-chip" v-if="appliedFilter.title">
                      <span class="search-chip__label">Judul</span>
                      <span class="search-chip__value">{{ appliedFilter.title }}</span>
                      <button
                        type="button"
                        class="search-chip__close"
                        @click="clearFilter('title')">
                        <v-icon size="14" color="#6B7280">mdi-close</v-icon>
                      </button>
                    </div>
                    <div class="search-chip" v-if="appliedFilter.year" :class="{ 'ml-2': appliedFilter.title }">
                      <span class="search-chip__label">Tahun</span>
                      <span class="search-chip__value">{{ appliedFilter.year }}</span>
                      <button
                        type="button"
                        class="search-chip__close"
                        @click="clearFilter('year')">
                        <v-icon size="14" color="#6B7280">mdi-close</v-icon>
                      </button>
                    </div>
                  </div>
                  <div
                    v-for="(item, index) in process.load ? 6 : list"
                    :key="index"
                    class="doc-card">
                    <v-skeleton-loader
                      v-if="process.load"
                      type="list-item-two-line"
                      class="pa-2"
                    ></v-skeleton-loader>
                    <template v-else-if="list.length > 0">
                      <div class="doc-card__row" @click="toDetail(item)" @mouseover="voiceHover(item.title)">
                        <div class="doc-card__icon" :style="`background: ${set_color}`">
                          <v-icon size="20" color="white">mdi-file-document-outline</v-icon>
                        </div>
                        <div class="doc-card__body">
                          <div class="doc-card__title-row">
                            <div class="doc-card__title">{{ item.title }}</div>
                          </div>
                          <div class="doc-card__meta">
                            <span class="doc-card__meta-item">
                              <v-icon size="13" color="#8A8F98">mdi-calendar-range</v-icon>
                              Tahun {{ item.year }}
                            </span>
                            <span class="doc-card__meta-item">
                              <v-icon size="13" color="#8A8F98">mdi-clock-outline</v-icon>
                              {{ item.input_datetime | date }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="doc-card__actions">
                        <v-btn
                          small
                          elevation="0"
                          :color="set_color"
                          @click="toDetail(item)"
                          @mouseover="voiceHover('Lihat Detail')"
                          class="text-capitalize font-weight-medium white--text doc-card__btn">
                          <v-icon size="16" class="mr-1">mdi-text-box-search-outline</v-icon>
                          Detail
                        </v-btn>
                      </div>
                    </template>
                  </div>

                  <div v-if="!process.load && pagination.total_data > 20 && limit < pagination.total_data"
                    class="text-center mt-4 mb-2">
                    <v-btn
                      @click="limit += 20"
                      :loading="process.limit"
                      small
                      rounded
                      outlined
                      elevation="0"
                      @mouseover="voiceHover('Lebih banyak')"
                      :color="set_color"
                      class="text-capitalize"
                      style="opacity: 60%;">
                      Lebih banyak
                    </v-btn>
                  </div>

                  <Empty v-if="!process.load && pagination.total_page < 1"
                    class="py-12"
                    margin="my-16"
                    size="125"
                    message="Propemperda" />
                </v-col>

                <v-col cols="12" md="3" v-if="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm'">
                  <v-card flat class="filter-sidebar">
                    <v-card-text class="pa-5">
                      <div class="filter-sidebar__title">
                        <v-icon size="16" :color="set_color" class="mr-2">mdi-tune-variant</v-icon>
                        <span :style="`color: ${set_color}`">Filter Data</span>
                      </div>

                      <v-text-field
                        solo
                        flat
                        hide-details
                        class="mb-3"
                        v-model="filter.title"
                        clearable
                        @click:clear="filter.title = ''"
                        @keydown.enter.prevent="applyFilter()"
                        :color="`${set_color}`"
                        placeholder="Judul">
                      </v-text-field>

                      <v-select
                        :items="years"
                        :color="`${set_color}`"
                        :item-color="`${set_color}`"
                        hide-details
                        class="mb-1"
                        v-model="filter.year"
                        clearable
                        @click:clear="filter.year = ''"
                        item-text="text"
                        item-value="value"
                        placeholder="Tahun"
                        solo
                        flat>
                      </v-select>

                      <v-btn
                        elevation="0"
                        block
                        height="36"
                        @click="applyFilter()"
                        @mouseover="voiceHover('Cari')"
                        :small="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? false : true"
                        :color="`${set_color}`"
                        class="text-subtitle-2 text-capitalize font-weight-bold white--text mt-3 filter-sidebar__btn">
                        <v-icon size="18" class="mr-2">mdi-magnify</v-icon>
                        Cari
                      </v-btn>
                    </v-card-text>
                  </v-card>

                  <Sidebar />
                </v-col>
              </v-row>
            </div>
          </v-container>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { createSEOMeta } from '@/utils/seo'
  export default {
    middleware: false,
    data () {
      return {
        filter: {
          title: '',
          year: ''
        },
        appliedFilter: {
          title: '',
          year: ''
        },
        dialog: {
          filter: false
        },
        list: [],
        pagination: {},
        limit: 20,
        process: {
          load: false,
          limit: false
        },
        message: {
          success: '',
          error: ''
        },
        content: {
          url: '/propemperda',
          title: 'Propemperda',
          description: 'Program Pembentukan Peraturan Daerah JDIH Setwan Kabupaten Klaten',
          image: require('@/assets/logo/favicon.png')
        }
      }
    },
    head () {
      return {
        title: this.content.title,
        meta: createSEOMeta(this.content)
      }
    },
    components: {
      Empty: () => import(/* webpackPrefetch: true */ '@/components/Empty'),
      Sidebar: () => import(/* webpackPrefetch: true */ '@/components/sidebar/index')
    },
    watch: {
      'limit': function () {
        this.process.limit = true
        this.fetch('limit')
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      set_color () {
        return this.$store.state.header.config.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))
        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))
        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))
        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
      years () {
        let max = new Date().getFullYear(), min = max - 200, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      },
      hasActiveFilter () {
        return (this.appliedFilter.title !== '' && this.appliedFilter.title !== null) ||
          (this.appliedFilter.year !== '' && this.appliedFilter.year !== null)
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      voiceHover (item) {
        responsiveVoice.cancel()
        responsiveVoice.speak(item, 'Indonesian Female')
      },
      applyFilter () {
        this.appliedFilter = {
          title: this.filter.title || '',
          year: this.filter.year === null || this.filter.year === undefined ? '' : this.filter.year
        }
        this.dialog.filter = false
        this.fetch()
      },
      clearFilter (key) {
        this.filter[key] = ''
        this.appliedFilter[key] = ''
        this.fetch()
      },
      async fetch (type) {
        this.process.load = type === undefined ? true : false
        this.process.limit = true

        let params = {
          'title[lse]': this.appliedFilter.title || '',
          year: this.appliedFilter.year === null || this.appliedFilter.year === '' ? '' : this.appliedFilter.year,
          limit: this.limit,
          is_publish: 1,
          sort: '-year'
        }

        await this.$axios.$get(`${process.env.API}sites/propem/data`, { params })
          .then(response => {
            let res = response

            if (res.status === 200) {
              this.list = res.results.data
              this.pagination = res.results.pagination
              this.process.load = false
              this.process.limit = false
            }
          })
          .catch(() => {
            this.process.load = false
            this.process.limit = false
          })
      },
      toDetail (item) {
        this.$router.push(`/propemperda/${(item.title.split('-').join('=').split(' ').join('-').split('/').join('>'))}?q=${item.id}`)
      }
    }
  }
</script>

<style scoped>
.doc-page {
  background-color: #F7F8FA;
}

/* Header */
.doc-header {
  margin-bottom: 18px;
  padding: 20px 22px;
  border: 1px solid #E7ECF2;
  border-radius: 16px;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, rgba(249, 251, 253, 0.98) 100%);
}
.doc-header__topline {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 2px;
}
.doc-header__eyebrow {
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  opacity: 0.85;
}
.doc-header__main {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
}
.doc-header__title-wrap {
  min-width: 0;
}
.doc-header__title {
  font-weight: 700;
  color: #1D232A;
  line-height: 1.15;
  letter-spacing: -0.02em;
}
.doc-header__title--lg {
  font-size: 20px;
}
.doc-header__title--sm {
  font-size: 18px;
}
.doc-header__subtitle {
  margin-top: 8px;
  color: #66707C;
  font-size: 13.5px;
  line-height: 1.55;
  max-width: 560px;
}
.doc-header__meta {
  flex: none;
}
.doc-header__count {
  min-height: 38px;
  padding: 0 14px;
  border: 1px solid #E2E8F0;
  border-radius: 999px;
  background: #FFFFFF;
  color: #475467;
  display: inline-flex;
  align-items: center;
  font-size: 12.5px;
  font-weight: 600;
  white-space: nowrap;
}
.doc-filter-trigger {
  min-height: 36px;
  padding: 0 12px;
  border: 1px solid #D7E1ED;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.94);
  color: #475467;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12.5px;
  font-weight: 600;
  transition: background-color 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
}
.doc-filter-trigger:hover {
  background: #FFFFFF;
  border-color: #C8D6E5;
  transform: translateY(-1px);
}
.doc-filter-trigger:focus,
.doc-filter-trigger:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(46, 125, 225, 0.14);
}
.search-chip {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  min-height: 42px;
  padding: 8px 10px 8px 14px;
  border: 1px solid #E3E8EF;
  border-radius: 14px;
  background: #FFFFFF;
}
.search-chip__label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #7A838F;
}
.search-chip__value {
  color: #20262D;
  font-size: 13px;
  font-weight: 600;
}
.search-chip__close {
  width: 26px;
  height: 26px;
  border: 0;
  border-radius: 999px;
  background: #F3F5F8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
}
.search-chip__close:hover {
  background: #E9EEF4;
}

/* Document card */
.doc-card {
  background: #FFFFFF;
  border: 1px solid #E7E9EC;
  border-radius: 10px;
  margin-bottom: 12px;
  padding: 16px 18px;
  transition: box-shadow 0.15s ease;
}
.doc-card:hover {
  box-shadow: 0 4px 16px rgba(20, 22, 25, 0.06);
}
.doc-card__row {
  display: flex;
  align-items: flex-start;
  cursor: pointer;
}
.doc-card__icon {
  flex: none;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
}
.doc-card__body {
  min-width: 0;
  flex: 1;
}
.doc-card__title-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}
.doc-card__title {
  font-size: 15px;
  font-weight: 600;
  color: #1F2328;
  line-height: 1.4;
  flex: 1;
}
.doc-card__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 14px;
  margin-top: 8px;
}
.doc-card__meta-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12.5px;
  color: #71767D;
  white-space: nowrap;
}
.doc-card__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #F0F1F3;
}
.doc-card__btn {
  border-radius: 7px !important;
  letter-spacing: 0.01em;
}

/* Filter sidebar */
.filter-sidebar {
  border: 1px solid #E7E9EC !important;
  border-radius: 10px !important;
}
.filter-sidebar__title {
  display: flex;
  align-items: center;
  font-size: 13.5px;
  font-weight: 700;
  letter-spacing: 0.02em;
  margin-bottom: 14px;
}
.filter-sidebar__btn {
  border-radius: 8px !important;
  min-height: 36px !important;
  font-size: 13px !important;
  letter-spacing: 0 !important;
}
.filter-sidebar__btn .v-icon {
  font-size: 16px !important;
}
.filter-sidebar >>> .v-input__slot {
  border-radius: 8px !important;
  background: #F4F5F7 !important;
  box-shadow: none !important;
  min-height: 42px !important;
}
.filter-sidebar >>> .v-text-field--solo > .v-input__control > .v-input__slot {
  min-height: 42px !important;
}
.filter-sidebar >>> .v-text-field__slot input,
.filter-sidebar >>> .v-text-field__slot input::placeholder,
.filter-sidebar >>> .v-text-field__slot {
  font-size: 13px !important;
}
.filter-sidebar >>> .v-input__append-inner,
.filter-sidebar >>> .v-input__prepend-inner {
  margin-top: 9px !important;
}

/* Filter dialog (mobile) */
.filter-dialog {
  border-radius: 10px !important;
}
.filter-dialog__header {
  border-bottom: 1px solid #F0F1F3;
}
.filter-dialog__title {
  font-size: 15px;
  font-weight: 700;
  color: #22262B;
}
.filter-dialog >>> .v-input__slot {
  border-radius: 8px !important;
  background: #F4F5F7 !important;
  box-shadow: none !important;
}

@media (max-width: 1300px) {
  .doc-card {
    padding: 14px;
  }
}
@media (max-width: 900px) {
  .doc-header {
    padding: 18px 16px;
    border-radius: 14px;
  }
  .doc-header__main {
    flex-direction: column;
    align-items: flex-start;
  }
  .doc-header__subtitle {
    max-width: none;
  }
}
</style>
